import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { isSuperFormControlLabel } from "./utils.es.js";
import EzFormControlLabelMui from "./Implementations/EzFormControlLabelMui.es.js";
const EzFormControlLabel = forwardRef((props, ref) => {
  if (isSuperFormControlLabel(props)) {
    const { checked: checked2, control: control2, disabled: disabled2 = false, icon, label: label2, value: value2 } = props;
    return /* @__PURE__ */ jsx(
      EzFormControlLabelMui,
      {
        ref,
        checked: checked2,
        control: control2,
        disabled: disabled2,
        icon,
        label: label2,
        value: value2
      }
    );
  }
  const { checked, control, disabled = false, helperText, label, labelIcons, value } = props;
  return /* @__PURE__ */ jsx(
    EzFormControlLabelMui,
    {
      ref,
      checked,
      control,
      disabled,
      helperText,
      label,
      labelIcons,
      value
    }
  );
});
EzFormControlLabel.displayName = "EzFormControlLabel";
export {
  EzFormControlLabel as default
};
//# sourceMappingURL=EzFormControlLabel.es.js.map
